import instance from "./ApiServices";
import authHeader from "./auth-header";

const getAll = () => {
  return instance.get("/slider", { headers: authHeader() });
};

const get = (id) => {
  return instance.get(`/slider/${id}`, { headers: authHeader() });
};

const create = (data) => {
  return instance.post("/slider", data, { headers: authHeader() });
};

const update = (id, data) => {
  return instance.post(`/slider/${id}?_method=PUT`, data, {
    headers: authHeader(),
  });
};

const remove = (id) => {
  return instance.delete(`/slider/${id}`, { headers: authHeader() });
};

const removeAll = () => {
  return instance.delete(`/slider`);
};

const findByTitle = (title) => {
  return instance.get(`/slider?title=${title}`);
};

const SliderService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default SliderService;
